import { useUserStore } from '@oai-frontend-monorepo/state-management';
import useSignIn from '../../api/sign-in';
import SignInForm from './sign-in.component';

interface Props {
  onSuccess?: () => void;
}

const SignInFormContainer = ({ onSuccess }: Props) => {
  const userStore = useUserStore();

  const { mutate, isPending } = useSignIn({
    onSuccess: (d) => {
      console.log('setting token');
      userStore.setToken(d);
      onSuccess?.();
    },
  });

  const onSubmit = (email?: string, password?: string) => {
    mutate({ email, password });
  };

  return <SignInForm signIn={onSubmit} isSubmitting={isPending} />;
};

export default SignInFormContainer;
